import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Switch } from 'react-router-dom';

import AuthRoute from '../components/auth-route';
import Report from '../sub-projects/reports/main';

// import UnauthRoute from '../components/unauth-route';

class IntegrationsRoutes extends React.Component<any, any> {
  public render() {
    return (
      <div>
        <Switch>
          <AuthRoute exact={true} path='/console/tenants/:tenantid/reports' component={Report} redirectTo='/' />
          <Redirect to='/' />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { ...state };
}

export default connect(
  mapStateToProps
)(IntegrationsRoutes);




// WEBPACK FOOTER //
// ./src/routes/reports.tsx